import baseUrl from "../Api/baseUrl";

const useDeleteData = async (url, body = {}) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
    },
    data: body,
  };

  try {
    const res = await baseUrl.delete(url, config);
    return res.data;
  } catch (error) {
    console.error("Delete request failed:", error);
    throw error;
  }
};

export default useDeleteData;
